import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { ITemplateCategory } from '../../constants/templates';

const useStyles = makeStyles((theme) => ({
    sidebarItem: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 1.5),
        borderRadius: theme.spacing(1),
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        gap: theme.spacing(1.5),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            transform: 'scale(1.02)',
        },
    },
    selectedSidebarItem: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    sidebarIcon: {
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarLabel: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    expandIcon: {
        marginLeft: 'auto',
        fontSize: 20,
    },
}));

interface ICategoriesList {
    category: ITemplateCategory;
    selectedMenuOption: string;
    hasSubcategories: boolean;
    isExpanded?: boolean;
    onCategoryClick: (e?: React.MouseEvent) => void;
}

export const CategoriesList = ({
    category,
    selectedMenuOption,
    hasSubcategories,
    isExpanded = false,
    onCategoryClick,
}: ICategoriesList) => {
    const classes = useStyles();

    const isSelected = selectedMenuOption === category.id && !hasSubcategories;

    return (
        <Box
            className={`${classes.sidebarItem} ${
                isSelected ? classes.selectedSidebarItem : ''
            }`}
            onClick={onCategoryClick}
            data-testid={`menu-option-${category.id}`}
        >
            <Box className={classes.sidebarIcon}>{category.icon}</Box>
            <Typography variant="body2" className={classes.sidebarLabel}>
                {category.label}
            </Typography>
            {hasSubcategories && (
                <Box className={classes.expandIcon}>
                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                </Box>
            )}
        </Box>
    );
};
